export default {
  getParams () {
    console.log('get-params 123');
  }
}